const ja = {
  common: {
    appName: 'Digima',
    details: '詳細',
    search: '検索',
    skip: 'スキップ',
    cancel: 'キャンセル',
    ok: 'OK',
    confirm: '確認',
  },
  startup: {
    connectionErrorTitle: '接続できません',
    connectionErrorMessage:
      'サーバーに接続できませんでした。通信環境をご確認のうえ、再試行してください。',
    retry: '再試行',
  },
  aiTranscriptionConsent: {
    title: 'AI機能のご利用にあたって',
    intro:
      '本アプリのインプット戦略ノート機能では、インプット音声から生成した文字起こしテキストを、AIによる戦略ノート生成のため Amazon Web Services, Inc. に送信します。',
    bulletSentData: '・送信される情報：インプット音声の文字起こしテキスト',
    bulletDestination: '・送信先：Amazon Web Services, Inc.',
    bulletPurpose:
      '・利用目的：AIによる戦略ノートの自動生成のみ（Amazon Web Services, Inc. のAIモデルの学習には使用されません）',
    declineConsequence:
      '本機能はインプットとAI戦略ノートが一体のため、「同意しない」を選択した場合はインプットは開始されません。',
    privacyPrefix: '詳細は',
    privacyLink: 'プライバシーポリシー',
    privacySuffix: 'をご確認ください。',
    agree: '同意して進む',
    decline: '同意しない',
  },
  auth: {
    signInAlertTitle: '重要なお知らせ',
    signInSubtitle:
      '本アプリは現在、Digima AIエージェントをご契約のアカウントから順次ご提供しています。\n未契約のアカウントへの提供もご案内予定ですので、\nしばらくお待ちください。\n詳細やご質問はお問い合わせください',
    signInButton: 'Digimaにログイン',
    errors: {
      invalidCallback: '無効なコールバックURLです',
      stateMismatch: 'ステートが一致しません',
      loginFailed: 'ログインに失敗しました',
      userDisabled: 'このアカウントは無効のためログインできません。',
      accountLocked: 'アカウントがロックされました。パスワードをリセットして解除してください。',
      failedToGetAuthLink: '認証リンクの取得に失敗しました',
      loginNoData: 'ログインに失敗しました：データが返されませんでした',
      oauth: {
        accessDenied:
          'アクセスが拒否されました。このアプリケーションを使用する権限がない可能性があります。',
        serverError: '認証サーバーでエラーが発生しました。しばらくしてからもう一度お試しください。',
        unknown: '予期しない認証エラーが発生しました。もう一度お試しください。',
      },
    },
  },
  contacts: {
    loadError: '連絡先の読み込みに失敗しました',
    empty: '結果はありません',
    emptyDescription: '検索の結果、該当する顧客は見つかりませんでした。',
    picker: {
      searchPlaceholder: '顧客を検索する...',
      viewProfile: 'プロフィールを表示',
      seeMemo: 'メモを表示',
      memoSection: '手書きメモ',
      seeMore: 'もっと読む',
      detailsSection: '顧客情報項目',
      profileScreenTitle: '%{name}さんの詳細情報',
      statusLabel: 'ステータス: %{name}',
    },
    lastAction: {
      label: '%{action} %{time}',
      types: {
        contactSmsInboundMessageReceived: 'SMS受信',
        contactSmsOutboundMessageSent: 'SMS送信',
        contactEmailClicked: 'メールクリック',
        contactEmailInboxOpened: 'メール開封',
        contactPageVisited: 'ページ訪問',
        contactLineInboundMessageReceived: 'LINE受信',
        contactLineClicked: 'LINEクリック',
        contactSmsLinkClicked: 'SMSリンククリック',
        unknown: '最終アクティビティ',
      },
      time: {
        justNow: 'たった今',
        minutesAgo: '%{count}分前',
        hoursAgo: '%{count}時間前',
        daysAgo: '%{count}日前',
        monthsAgo: '%{count}ヶ月前',
        yearsAgo: '%{count}年前',
      },
    },
    notesSheet: {
      title: '%{name}さんのメモの詳細',
    },
    filter: {
      assignedToMe: '自分の担当',
      allContacts: 'すべての連絡先',
    },
    profile: {
      accessDenied: 'この連絡先を閲覧する権限がありません。',
      loadError: '連絡先の詳細の読み込みに失敗しました',
      noMemo: '表示するメモはありません',
      noDetails: '表示する詳細情報はありません',
      dateTime: '日時',
      meetingMemosLoadError: '面談メモの読み込みに失敗しました',
      status: 'ステータス',
      noStatus: 'ステータスなし',
      statusUpdateFailed: 'ステータスの更新に失敗しました',
      personInCharge: '担当者',
      noPersonInCharge: '未割り当て',
      personInChargeUpdateFailed: '担当者の更新に失敗しました',
      personalInfo: '個人情報',
      workInfo: '勤務先情報',
      email: 'メールアドレス',
      personalMobile: '携帯電話',
      personalLandline: '固定電話',
      age: '年齢',
      gender: '性別',
      company: '会社名',
      department: '部署',
      jobTitle: '役職',
      workLandline: '会社電話',
      workMobile: '会社携帯',
      attributeLabels: {
        id: '顧客情報ID',
        companyId: '会社ID',
        uid: '顧客UID',
        firstName: '名',
        firstNameKana: '名（カナ）',
        lastName: '姓',
        lastNameKana: '姓（カナ）',
        fullName: '氏名',
        email: 'メールアドレス',
        age: '年齢',
        gender: '性別',
        personalMobileNumber: '個人携帯電話番号',
        personalMobileNumberCountryCode: '個人携帯電話国番号',
        personalLandlineNumber: '自宅固定電話番号',
        personalLandlineNumberCountryCode: '自宅固定電話国番号',
        personalFaxNumber: '自宅ファックス番号',
        personalFaxNumberCountryCode: '自宅ファックス国番号',
        personalCountry: '自宅国',
        personalRegion: '自宅都道府県',
        personalCity: '自宅市区町村',
        personalPostalCode: '自宅郵便番号',
        personalAddress1: '自宅住所１',
        personalAddress2: '自宅住所２',
        personalWebsiteUrl: '個人ウェブサイトURL',
        workCompanyName: '勤務先会社名',
        workWebsiteUrl: '会社ウェブサイトURL',
        workDepartment: '勤務先部署名',
        workJobTitle: '勤務先役職名',
        workLandlineNumber: '勤務先固定電話番号',
        workLandlineNumberCountryCode: '勤務先固定電話国番号',
        workMobileNumber: '勤務先携帯電話番号',
        workMobileNumberCountryCode: '勤務先携帯電話国番号',
        workFaxNumber: '勤務先ファックス番号',
        workFaxNumberCountryCode: '勤務先ファックス国番号',
        workCountry: '勤務先国',
        workRegion: '勤務先都道府県',
        workCity: '勤務先市区町村',
        workPostalCode: '勤務先郵便番号',
        workAddress1: '勤務先住所１',
        workAddress2: '勤務先住所２',
        notes: 'メモ',
        contactStatusId: '顧客ステータス',
        personInChargeId: '担当者',
        firstApproachedAt: '初回連絡日時',
        lastApproachedAt: '直近連絡日時',
        creationMethod: '作成方法',
        lastActionType: '直近顧客行動タイプ',
        lastActionOccurredAt: '直近顧客行動日時',
        archivedAt: '追加日時',
        createdAt: '作成日',
        updatedAt: 'アップデート日時',
        customerType: '顧客種別',
        leadAcquisitionChannels: '反響経路',
        realEstateInquiry: {
          clientSelectedPlan: '問い合わせ企画',
          inquiredAt: '問い合わせ日時',
          preferredModeOfCommunication: '希望連絡方法',
          preferredTimeOfCommunication: '希望曜日時間帯',
          content: '問い合わせ内容',
          yearlyIncome: '年収',
        },
        realEstateConstructionInquiry: {
          locationDetails: '建築予定地・土地の有無',
          plannedTiming: '建築予定時期',
          budget: '建築予算',
          requirements: '建築要望',
          type: '問い合わせ種別',
          modelHouseName: '問い合わせモデルハウス名',
          reservationTiming: '予約希望日時',
          eventName: '問い合わせイベント名',
          eventTiming: '問い合わせイベント開催日時',
          preferredCatalogName: '請求カタログ名',
          exhibitionVenueName: '問い合わせ展示場名',
        },
        realEstatePurchaseInquiry: {
          propertyType: '購入物件種別',
          propertyName: '購入物件名',
          preferredMoveInDate: '入居希望時期',
          propertyImageUrl: '購入物件詳細画面',
          preferredPropertySpecification: '購入希望詳細',
          preferredArea: '購入希望エリア',
        },
        realEstateSaleInquiry: {
          propertyType: '売却物件種別',
          propertyAddress: '売却物件住所',
          propertyLandArea: '売却土地面積',
          propertyBuildingArea: '売却建物面積',
          propertyFloorPlan: '売却物件間取り',
          propertyAge: '売却物件築年',
          propertyVacancyStatus: '現況',
          propertyOwnerName: '名義',
          preferredSaleTime: '売却希望時期',
          saleReason: '売却理由',
          preferredAssessmentMethod: '査定方法',
          offerPrice: '売却希望価格',
          requests: '売却要望',
        },
      },
      attributeValues: {
        gender: {
          male: '男性',
          female: '女性',
          other: 'その他',
          notSpecified: '不明',
        },
        creationMethod: {
          api: 'API',
          import: 'インポート',
          leadAcquisition: '問い合わせ',
          webInterface: 'ウェブインターフェース',
          smsReceived: 'SMS受信',
          lineFriends: 'LINE友だち',
          andpad: 'ANDPAD',
          kintone: 'kintone',
          sentFromFranchisor: '本部からの送客',
          unknown: '不明',
        },
        lastActionType: {
          emailClicked: 'メールクリック',
          emailOpened: 'メール開封',
          emailReceived: 'メール受信',
          emailSent: 'メール送信',
          leadAcquisition: '問い合わせ',
          pageVisited: 'ページ閲覧',
          emailUnsubscribed: 'メール配信停止',
          lineClicked: 'LINEクリック',
          smsClicked: 'SMSクリック',
          smsReceived: 'SMS受信',
          lineFriendAdded: 'LINE友だち追加',
          lineMessageReceived: 'LINE受信',
          lineMessageSent: 'LINEチャット送信',
          unknown: '不明',
        },
      },
      notes: 'メモ',
      voiceRecordings: '音声インプット',
      serverRecordings: 'サーバー上の音声インプット',
    },
  },
  meetings: {
    title: '対応音声インプット',
    titleMyMemos: '私の対応音声インプット',
    titleAllMemos: '全ての対応音声インプット',
    offlineBanner: 'お使いのデバイスはオフラインです。',
    noInternetBanner: '端末がインターネットに接続されていません。',
    noWifiBanner: '端末がWi-Fiに接続されていません。',
    attentionBanner: '対応音声インプットの戦略ノートが作成できていないためエラーをご確認ください。',
    aiSummaryGenerated: '戦略ノート生成済み',
    aiSummaryInProgress: '戦略ノート作成中',
    aiSummaryUnavailable: 'AI戦略ノートが利用できません',
    aiSummaryOnHold: '戦略ノート生成失敗：月間音声インプット分数に達しました',
    pendingUpload: '戦略ノート利用不可：Wi-Fi未接続',
    uploadFailed: 'アップロード失敗',
    noRecording: '音声インプットなし',
    missingAttendees: '顧客が紐付けされていない',
    fixIssues: '問題を修正する',
    addAttendees: '対応を顧客と紐付ける',
    turnOnWifi: 'Wi-Fiをオンにする',
    changeUploadSettings: 'モバイルデータ設定変更',
    loadError: '面談の読み込みに失敗しました',
    empty: '対応音声インプットはありません',
    emptyDescription:
      '面談メモはDigimaアプリを通じてAIで面談を記録します。音声をインプットすると、AIが生成した戦略ノートが面談ログとして保存されます。',
    emptyMyDescription:
      'まだ面談メモがありません。音声インプットを開始して最初の面談メモを作成しましょう。',
    emptyAllDescription: '現在選択されている担当者の対応音声インプットはまだ登録されていません。',
    emptyAction: '今すぐ対応音声インプットを開始する',
    attendeeCount: '%{count}人の参加者',
    attendeeSummary: {
      one: '%{name}さんとの対応音声インプット',
      other: '%{name}さんと他%{count}名の対応音声インプット',
    },
    filter: {
      myMeetings: '自分の面談',
      allMeetings: 'すべての面談',
      personInCharge: '担当者',
      selectPersonInCharge: '担当者を選択してください',
      me: '自分',
      all: '全員',
    },
    detail: {
      headerTitle: '対応音声インプット詳細',
      loadError: '面談の詳細の読み込みに失敗しました',
      titleField: 'タイトル',
      dateTime: '日時',
      endsAt: '終了',
      location: '場所',
      personInCharge: '対応担当者',
      selectPersonInCharge: '担当者を選択してください',
      attendees: '紐付けた顧客情報',
      attendeesPlaceholder: '顧客情報を1名以上選択してください',
      attendeesCount: '%{count}件の連絡先を選択中',
      contactPickerTitle: 'この対応に同席していた顧客を選択してください',
      unknownContact: '不明な連絡先',
      voiceRecording: '音声インプット',
      recordingAvailable: '音声インプットあり',
      transcription: '文字起こし',
      summary: '戦略ノート',
      seeMore: 'もっと読む',
      copyText: '戦略ノートをコピー',
      copiedToClipboard: 'クリップボードにコピーしました',
      recordingSummary: {
        pending: '保留中',
        processing: '処理中',
        completed: '完了',
        failed: '失敗',
        completedAt: '完了日時',
        summary: '戦略ノート',
        transcript: '文字起こし',
        topics: 'トピック',
      },
      summaryInProgress: '戦略ノートを生成中です。準備ができ次第、プッシュ通知をお送りします。',
      summaryWifiUnavailable: '生成待機：Wi-Fi接続を待機中です。',
      summaryQuotaExceeded:
        '生成待機：月間利用分を超過しました。%{date}午前1時に利用枠がリセットされた後、戦略ノートが生成されます。',
      summaryFailed: '利用不可：AI戦略ノートを作成できませんでした。',
      summaryUploadFailed: '利用不可：アップロードに失敗しました。',
      summaryNotAvailableImported: 'インポートされた対応音声インプットでは生成できません',
      summaryNoSpeechDetected: '音声インプットに検出可能な音声が含まれていません。',
      scheduledRecordingCta:
        'AI戦略ノートを生成するには、今すぐ音声インプットの面談を開始してください。',
      memo: '手書きメモ',
      memoMaxLength: '手書きメモは%{max}文字以内で入力してください',
      notes: '手書きメモ',
      notesPlaceholder: 'メモを追加',
      notesSaved: 'メモを保存しました',
      notesSaveFailed: 'メモの保存に失敗しました',
      saved: '面談を保存しました',
      saveFailed: '面談の保存に失敗しました',
      save: '保存',
      cancel: 'キャンセル',
      selectTime: '時刻を選択',
      month: '月',
      year: '年',
      backToDate: '日付に戻る',
      previousMonth: '前の月',
      nextMonth: '次の月',
      previousYear: '前年',
      nextYear: '翌年',
      hourInputAccessibilityLabel: '時間',
      minuteInputAccessibilityLabel: '分',
    },
  },
  aiTasks: {
    title: 'AIバトン',
    emptyTitle: '商談のチャンスを逃さない！\nAIとのバトン管理',
    emptyDescription: '今、あなたに回ってきたバトンはありません',
    aiSuggestionsLabel: 'AIの提案情報: ',
    aiSuggestionsBody:
      'コールスクリプトからSMS返信の内容に至るまで、Digima AIは、業務を迅速かつ効率的に遂行するために必要な情報を提案します',
    pushNotificationsLabel: 'プッシュ通知: ',
    pushNotificationsBody: '重要な依頼をスマホに即座にお知らせ。対応のチャンスを逃しません',
    loadError: 'AIバトンの読み込みに失敗しました',
    urgentSectionTitle: '緊急: お客様が24時間待っています',
    card: {
      defaultDescription: {
        manualPhoneCall: '%{name}さんとのお電話での面談アポイントを獲得できました！',
        meetingAppointmentSecured: '%{name}さんとの面談日程が確定しました！',
        scheduleMeetingAppointment:
          '%{name}さんとの面談日程の変更ご希望です。別のお日にちで調整を進めましょう！',
        sendDocuments: '%{name}さんから資料送付のご依頼をいただきました！',
        printMaterialsSentMail: '%{name}さんへの紙の資料の郵送手配が完了しました',
        propertyAvailabilityCheck:
          '%{name}さんから物件の空室状況についてお問い合わせをいただきました！関心が高まっているチャンスです',
      },
    },
    filter: {
      all: '全て',
      contact: '顧客',
      createdAt: 'バトン作成日',
      personInCharge: '担当者',
      selectContact: '顧客を選ぶ',
      selectCreatedAt: 'バトン作成日を選ぶ',
      selectPersonInCharge: '担当者を選ぶ',
      searchContactPlaceholder: '顧客名で検索する...',
      dateRange: {
        today: '今日',
        last7Days: '過去7日間以内',
        thisWeek: '今週以内',
        last30Days: '過去30日間以内',
        thisMonth: '今月以内',
      },
    },
    severity: {
      urgent: '緊急',
      important: '重要',
      moderatelyImportant: 'やや重要',
    },
    section: {
      important: '重要',
      moderatelyImportant: 'やや重要',
      other: 'その他',
    },
    badge: {
      awaitingClaim: 'バトン待ち',
      assignedToMe: '自分の担当',
      unassignedTooLong: '長時間担当なし',
    },
    action: {
      claim: 'バトンを受け取る',
      claimAndOpen: 'バトンを受け取って詳細へ',
      release: 'バトンを戻す',
    },
    error: {
      claimFailed: 'バトンの受け取りに失敗しました',
      releaseFailed: 'バトンを戻せませんでした',
    },
    releaseOthersConfirm: {
      title: '他の担当者のバトンを戻しますか？',
      body: 'このバトンは%{name}さんが担当しています。戻すと担当が解除され、誰でも受け取れる状態になります。',
      bodyUnknownHolder:
        'このバトンは他の担当者が担当しています。戻すと担当が解除され、誰でも受け取れる状態になります。',
      confirm: 'それでも戻す',
      dismiss: 'キャンセル',
    },
    handoffType: {
      manualPhoneCall: '電話依頼',
      printMaterialsSentMail: '資料郵送',
      meetingAppointmentSecured: '面談確定',
      scheduleMeetingAppointment: '日程調整',
      sendDocuments: '資料送付',
      propertyAvailabilityCheck: '物件確認',
    },
    detail: {
      defaultDescription: {
        manualPhoneCall:
          '%{name} 様とのお電話での面談アポイントを獲得できました！お時間になりましたら、下記の情報を参考しお客様へお電話をお願いいたします。',
        meetingAppointmentSecured:
          '%{name} 様との面談日程が無事に確定いたしました。今回は内容のご確認のみとなりますので、お客様への返信等のアクションは不要です。当日に向けて、以下の事前情報をご確認ください。',
        scheduleMeetingAppointment:
          '%{name} 様との面談日程が無事に確定いたしました。今回は内容のご確認のみとなりますので、お客様への返信等のアクションは不要です。当日に向けて、以下の事前情報をご確認ください。',
        printMaterialsSentMail:
          '%{name} 様への紙の資料の郵送手配が完了いたしました。お手元に届くころのフォローが効果的です。以下の内容をご確認いただき、必要に応じてお客様へのご連絡をお願いいたします。',
        propertyAvailabilityCheck:
          '%{name} 様より、ご希望の物件の空室状況についてお問い合わせをいただきました！ご検討が進んでいるサインです。以下の内容をご確認のうえ、空き状況の確認とお客様へのご返信をお願いいたします。',
        sendDocuments:
          '%{name} 様から、郵送での資料送付のご依頼（ご承諾）をいただきました！紙のカタログを手に取っていただくことで、自社の魅力をより深くお伝えできる大チャンスです。以下の内容で資料の発送手配をお願いいたします。',
      },
      title: {
        manualPhoneCall: '電話対応依頼詳細',
        printMaterialsSentMail: '資料郵送依頼詳細',
        meetingAppointmentSecured: '面談確定依頼詳細',
        scheduleMeetingAppointment: '日程調整依頼詳細',
        sendDocuments: '資料送付依頼詳細',
        propertyAvailabilityCheck: '物件確認依頼詳細',
      },
      subtitle: {
        assignedToMe: '自分の担当',
        awaitingClaim: 'バトン待ち',
        claimedByOther: '担当あり',
      },
      notClaimedWarning:
        'このバトンはまだ受け取られていません。対応するにはまずバトンを受け取る必要があります。',
      statusLabel: 'ステータス：%{status}',
      noStatus: 'ステータスなし',
      tab: {
        activity: 'アクティビティ履歴',
        customer: '顧客情報',
      },
      chip: {
        sms: 'SMSメッセージ',
        correspondence: '対応記録',
      },
      meetingCard: {
        title: '対応記録',
        description:
          'ユーザーの%{user}さんが、%{attendees}さんに「%{meeting}」の対応をしました（Digimaモバイルアプリの録音から要約）',
        descriptionNoAttendees:
          'ユーザーの%{user}さんが「%{meeting}」の対応をしました（Digimaモバイルアプリの録音から要約）',
        summaryTab: '要約',
        notesTab: '手書きメモ',
        noSummary: '要約はまだありません',
        noNotes: '手書きメモはありません',
        readMore: 'もっと読む',
      },
      close: '閉じる',
      call: '電話する',
      createSms: 'SMS作成',
      aiAgentName: 'Digima AIエージェント',
      customerName: '顧客',
      smsEmpty: 'SMSメッセージはありません',
      smsLoadError: '会話の読み込みに失敗しました',
      meetingsLoadError: '対応記録の読み込みに失敗しました',
      retry: '再試行',
      smsSending: '送信中',
      correspondenceEmpty: '対応記録はありません',
      customerMemo: '顧客メモ',
      customerFields: '顧客情報項目',
      readMore: 'もっと読む',
      field: {
        lastName: '姓',
        firstName: '名',
        email: 'メールアドレス',
        mobileNumber: '携帯電話番号',
      },
      noContact: '顧客が紐付けられていません',
      loadError: 'バトンの読み込みに失敗しました',
      noPhoneNumber: '電話番号が登録されていません',
      callFailed: 'この端末では発信できませんでした',
      callConfirm: {
        title: '顧客に電話しますか？',
        body: '%{name}に電話をかけます。よろしいですか？',
        confirm: '電話する',
        dismiss: 'キャンセル',
      },
      smsCompose: {
        title: 'SMS送信',
        bodyPlaceholder: '内容を入力してください',
        lastNameLabel: '姓',
        bodyLabel: '本文',
        charCount: '約%{length}/600',
        cancel: 'キャンセル',
        send: 'SMS送信',
        confirmTitle: '送信しますか？',
        confirmBody: 'このSMSを顧客に送信します。',
        confirm: '送信',
        dismiss: 'キャンセル',
        sendFailed: 'SMSの送信に失敗しました',
        sent: 'SMSを送信しました',
        bodyRequired: '本文を入力してください',
        charLimit: 'このメッセージは文字数制限に達しました。',
      },
    },
  },
  onboarding: {
    welcome: {
      title: '対応を音声インプットし、戦略ノートからフォローアップを強化する',
      body: 'ワンタップでオフラインでの対応を音声インプット。AIが音声インプットから「顧客の懸念点」「合意事項」「ネクストアクション」などを抽出し、客観的な事実として自動でデータ化します。',
      nextButton: '次へ、使い方を確認する',
      skipButton: 'スキップ',
    },
    step1: {
      title: 'ステップ1：商談や打ち合わせなどの対応を音声インプット',
      body: '対応内容の戦略ノートを作成するには、まずその内容を音声インプットする必要があります。音声インプットを開始するには、下部メニューに常に表示されている「音声インプット開始」ボタンを押しましょう。',
      nextButton: '次へ',
      skipButton: 'スキップ',
    },
    recordIllustration: {
      turnOnWifi: 'Wi-Fiをオンにする',
      changeUploadSettings: 'モバイルデータ設定変更',
      aiSummaryUnavailable: '戦略ノート生成失敗：Wi-Fi接続を待機中',
      consultationMeeting: '提案面談',
      meetingWith: '櫻井 康二さんとの対応音声インプット',
      time: '13:45',
      date: '2026年3月23日',
      aiSummaryInProgress: 'AI戦略ノート生成中',
      meetingMemosTab: '対応一覧',
      startRecordingTab: '音声インプット開始',
      settingsTab: '設定',
    },
    step2: {
      title: 'ステップ2：対応した顧客を紐付けする',
      body: '対応が終了したら、「停止」ボタンを押して音声インプットを停止し、参加者を含む対応の詳細を入力してください。その音声インプットデータはDigimaにアップロードされ、戦略ノートが生成されます。',
      nextButton: '次へ',
      skipButton: 'スキップ',
    },
    step3: {
      title: 'ステップ3：通知を受け取る',
      body: 'Digimaが戦略ノートの作成を完了するとDigimaモバイルアプリからお知らせします。',
      doneButton: '終了',
    },
  },
  tabs: {
    contacts: 'コンタクト',
    meetings: '対応記録',
    aiTasks: 'AIバトン',
    startRecording: '音声インプット開始',
    settings: '設定',
    help: 'ヘルプ',
  },
  settings: {
    title: '設定',
    versionLabel: 'バージョン {{version}}',
    logOutButton: 'ログアウト',
    signOutButton: 'サインアウト',
    profileError: 'プロフィールの読み込みに失敗しました',
    networkAndMobileData: '音声インプットアップロード',
    localMeetingRecordings: '未アップロード端末インプット',
    quotaUsage: {
      title: '今月の戦略ノートの利用状況',
      subtitle: '会社共有を含む音声インプット分数: %{used}/%{total}分',
      screenTitle: '戦略ノートの月間利用可能分数',
      description:
        '以下は、あなたと会社内の全ユーザーが1か月あたりに利用できる音声インプットの分数です。利用上限に達した場合でも音声インプットはDigimaにアップロードされますが、追加分を購入するか、月間利用枠が更新されるまで戦略ノートは生成されません。',
      personalQuotaTitle: '自分の戦略ノート利用可能分数',
      personalQuotaDescription:
        '自分のDigimaユーザーアカウントに割り当てられた月間利用枠です。この枠に達すると、自動的に会社の月間利用枠が使用されます。',
      personalQuotaLabel: '自分の戦略ノート利用分数可能枠',
      companyQuotaTitle: '会社共有の戦略ノート利用可能分数',
      companyQuotaDescription:
        '自分の会社のDigimaアカウントに割り当てられている月間利用枠です。この利用枠は、アカウント内のすべてのユーザーで共有されています。',
      companyQuotaLabel: '会社共有の戦略ノート利用分数可能枠',
      thisMonthUsage: '今月の利用分数',
      quotaReached: '月間クォータに達しました',
      quotaResetOn: '利用枠は%{date}午前1時にリセットされます',
      exceeded: '超過',
      minutesSuffix: '分',
    },
    uploadSettings: {
      title: '音声インプットアップロード',
      allowMobileData: 'モバイルデータの使用を可能にする',
      allowMobileDataDescription:
        'Digimaに音声インプットをアップロードする際、モバイルデータ利用を許可する設定になります。デフォルトでは、モバイルデータの使用を可能にする設定はOFFであり、端末がWi-Fiネットワークに接続されている場合のみ、音声インプットデータがアップロードされます。',
    },
    storage: {
      title: '未アップロード端末インプット',
      description:
        '戦略ノート作成のためにDigimaへのアップロードに失敗した音声インプットが、一時的に端末に保存されます。各対応音声インプットの下に表示されているエラーを修正すると、自動的に再アップロードが実行されます。',
      totalUsed: '使用済みのストレージ容量合計',
      voiceRecordings: '音声インプット',
      emptyMessage: 'ローカルに保存されている音声インプットはありません。',
      dateAndTime: '日時: %{date}',
      sizeAndRecorded: 'サイズ：%{size} - 音声インプット日時%{date}',
      localRecording: 'ローカル音声インプット',
    },
    storageUsage: 'ストレージ使用量',
    appInfo: {
      title: 'アプリ情報',
      privacyPolicy: 'プライバシーポリシー',
    },
  },
  recording: {
    actions: {
      recordVoice: '音声をインプット',
      expand: '拡大',
      pauseRecording: '一時停止',
      resumeRecording: '再開',
      stopPlayback: '停止',
      delete: '削除',
      deleteConfirmTitle: '音声インプットの削除',
      deleteConfirmMessage:
        'この音声インプットを削除してよろしいですか？この操作は元に戻せません。',
      deleteSuccess: 'ローカル音声インプットが削除されました',
      retry: 'アップロードを再試行',
      retrySuccess: '対応音声インプットが正常に更新されました',
      retryFailed: 'アップロードの再試行に失敗しました',
      uploadSuccess: '対応音声インプットが正常に更新されました',
      meetingCreated: '対応音声インプットが正常に作成されました',
      assignContacts: '連絡先を割り当て',
      assignContactsSuccess: '選択した連絡先に音声インプットをアップロードしました',
    },
    indicator: {
      recording: '音声インプット中...',
      paused: '一時停止中',
    },
    liveSurface: {
      recording: '音声インプット中',
      paused: '一時停止中',
    },
    fullScreen: {
      title: '音声インプット',
      minimize: '最小化',
      starting: '開始中...',
      recording: '戦略ノートのために音声インプット中',
      saving: '保存中...',
      paused: '戦略ノート用の音声インプットが一時停止されました',
      pause: '一時停止',
      resume: '再生',
      stop: '停止',
      cancelStart: 'キャンセル',
    },
    remaining: {
      hours: '残り約{{value}}時間',
      minutes: '残り約{{value}}分',
    },
    startConfirmation: {
      title: '対応音声インプットを開始しますか？',
      body: '対応音声インプットを開始してもよろしいですか？音声インプットは戦略ノートを作成するために使用されます。後日、この音声インプットを再生することはできません。',
      notePrefix: '',
      noteBody: '',
      noteSuffix: '',
      confirm: 'はい',
      dismiss: 'いいえ',
    },
    stopConfirmation: {
      title: 'この音声インプットを終了しますか？',
      body: 'この音声インプットを終了してもよろしいですか？',
      confirm: 'はい',
      dismiss: 'いいえ',
    },
    errors: {
      microphonePermissionDenied: '音声メモをインプットするにはマイクの許可が必要です。',
      notificationPermissionDenied: 'バックグラウンドで録音を続けるには通知の許可が必要です。',
      recordingFailed: '音声インプットの開始に失敗しました。もう一度お試しください。',
      encoderStalled: '音声入力が検出されませんでした。録音を停止しました。',
      recordingInterrupted: '音声インプットが中断されました。もう一度お試しください。',
      saveFailed: '音声インプットの保存に失敗しました。',
      deleteFailed: '音声インプットの削除に失敗しました。',
      invalidUserOrAccount:
        'ユーザーまたはアカウント情報が不足しています。再ログインしてください。',
      uploadFailed: '音声インプットのサーバーへのアップロードに失敗しました。',
      loadRemoteFailed: 'サーバーから音声インプットの読み込みに失敗しました。',
      loadAllFailed: '音声インプットの読み込みに失敗しました。',
      assignContactsFailed: '連絡先への音声インプットのアップロードに失敗しました。',
      recordingNotFound: '音声インプットが見つかりません。',
      lowStorageStopped: '端末の空き容量が少ないため、音声インプットを停止して保存しました。',
    },
    lowStorageWarning: {
      message: '端末の空き容量が少なくなっています。まもなく音声インプットが自動停止します。',
    },
    lowStorageStart: {
      title: '空き容量が不足しています',
      body: '空き容量が少なくなっています。長時間の録音が完了しない可能性があります。続けますか？',
      confirm: 'はい',
      dismiss: 'いいえ',
    },
    notifications: {
      appKilled: {
        title: '音声インプット中断',
        body: '音声インプットが予期せず中断されました。',
      },
      lowStorage: {
        title: '音声インプットを保存しました',
        body: '端末の空き容量が少ないため、音声インプットを停止して保存しました。',
      },
    },
    emptyList: '音声インプットはまだありません',
    contactPicker: {
      title: 'この対応に同席していた顧客を選択してください',
      selected: '%{count}件の連絡先を選択中',
      confirm: '対応を顧客と紐付ける',
    },
  },
  drawer: {
    status: {
      pending: 'アップロード待ち',
      uploading: 'アップロード中...',
      uploaded: 'アップロード済み',
      failed: 'アップロード失敗',
      pendingContact: '連絡先選択待ち',
    },
    empty: 'ローカル音声インプットはありません',
  },
  pushNotification: {
    errors: {
      permissionDenied:
        'プッシュ通知の許可が拒否されました。通知を受け取るには設定で有効にしてください。',
      registrationFailed: 'プッシュ通知の登録に失敗しました。もう一度お試しください。',
      unregisterFailed: 'プッシュ通知の登録解除に失敗しました。',
    },
  },
  notifications: {
    aiSummaryFailed: {
      title: '戦略ノートの生成に失敗しました',
      body: 'Wi-Fiをオンにするか、アップロード設定を変更してください',
    },
  },
  notificationPermissionPrompt: {
    title: '通知を有効化して、重要な営業タスクを即座にキャッチ',
    body: '面談タスクや、お客様からの電話依頼など、対応が必要なタスクを見逃さないためにプッシュ通知をご活用ください。外出先でも即座に対応でき、アポイント獲得のタイミングを逃しません',
    enableButton: '通知をオンにする',
    skipButton: 'スキップ',
  },
} as const;

export { ja };
